export const BALOISE_SESSION_KEY = 'baloise-persist-config';
export const BALOISE_ANIMATION_KEY = 'baloise-animated';
